module.exports = __webpack_public_path__ + "static/30-dece985f395600cb6279033160cf2ea8.png";